<template>
  <div class="header-top">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between">
        <a :href="baseUrlWithLocale" class="site-logo">
          <img
            :src="require('@javascript/packs/images/@tehnobank/logo.png')"
            alt="КОСМОС"
          />
        </a>
        <div class="d-flex">
          <div
            v-if="isLogin"
            class="header-top__profile-details d-none d-md-flex mr-md-4"
          >
            <a class="header-top__catalog-url" :href="catalogRouter">
              {{ t[locale]['tehnobank.header.catalog'] }}
            </a>

            <div class="header-top__profile-balance-wrapper d-md-none d-lg-block">
              <a class="header-top__text" :href="profileMyBalanceRouter">
                {{ t[locale]['tehnobank.header.your_balance'] }}
              </a>
              <span class="header-top__profile-balance">
                {{ renderUserBalance }} <span class="star">★</span>
              </span>

              <div class="bonuses-expire" v-if="userData.bonuses_will_expire > 0">
                <vl-tooltip :isCloseBtn="true">
                  <template #activator="on">
                    <div v-on="on" class="d-flex">
                      <vl-icon-base width="16" height="16" viewBoxWidth="16" viewBoxHeight="16" opacity="1">
                        <vl-icon-exclamation-mark />
                      </vl-icon-base>
                    </div>
                  </template>
                  <template>
                    <div>
                      {{ t[locale]['profile.my_balance.bonuses_can_expire'].replace('{bonuses}', userData.bonuses_will_expire) }}
                      <a :href="rulesPage" target="_blank">{{ t[locale]['profile.my_balance.rules'] }}</a>.
                    </div>
                  </template>
                </vl-tooltip>
              </div>
            </div>



            <div class="header-top__cart-wrapper">
              <cart
                :locale="locale"
                :default-locale="defaultLocale"
                :user-id="getUserId"
                :base-url-with-locale="baseUrlWithLocale"
              />
            </div>
          </div>
          <ul
            v-if="isLogin"
            class="dropdown-profile-navigation-wrapper"
            v-click-outside="() => hideDropdownProfileNavigation('tablet')"
          >
            <li>
              <button
                type="button"
                class="sign-in d-none d-md-block"
                @click="toggleDropdownProfileNavigation('tablet')"
              >
                {{ t[locale]['tehnobank.header.my_profile'] }}
              </button>
              <ul
                v-if="tablet"
                class="dropdown-profile-navigation dropdown-profile-navigation--tablet"
              >
                <li class="d-lg-none">
                  <div
                    class="header-top__profile-balance-wrapper header-top__profile-balance-wrapper--tablet"
                  >
                    <a
                      class="header-top__text header-top__text--dark"
                      :href="profileMyBalanceRouter"
                      >{{ t[locale]['tehnobank.header.your_balance'] }}</a
                    >
                    <span class="header-top__profile-balance">
                      {{ renderUserBalance }} <span class="star">★</span>
                    </span>
                  </div>
                </li>
                <li
                  v-for="(item, index) in profileMenu"
                  :key="index"
                  class="dropdown-profile-navigation__item"
                >
                  <a class="dropdown-profile-navigation__url" :href="item.url">
                    {{ item.title }}
                  </a>
                </li>
                <li class="dropdown-profile-navigation__item">
                  <span
                    class="dropdown-profile-navigation__url"
                    @click="API_LOGOUT"
                  >
                    {{ t[locale]['authorization.logout.exit'] }}
                  </span>
                </li>
              </ul>
            </li>
          </ul>
          <a
            v-if="!isLogin"
            :href="loginRouter"
            class="sign-in d-none d-md-block"
          >
            {{ t[locale]['tehnobank.header.enter_to_account'] }}
          </a>
          <div class="d-none d-md-block">
            <language-container
              v-if="this.disableOnPage(baseUrlWithLocale)"
              :available-locales="availableLocales"
              :current-path="currentPath"
              :locale="locale"
              :baseUrlWithLocale="baseUrlWithLocale"
            />
          </div>
          <ul
            v-if="isLogin"
            class="d-md-none dropdown-profile-navigation-wrapper"
          >
            <li class="d-flex">
              <button
                type="button"
                class="burger-menu"
                @click="toggleDropdownProfileNavigation('mobile')"
              >
                <span class="burger-menu__item"></span>
                <span class="burger-menu__item"></span>
                <span class="burger-menu__item"></span>
              </button>
            </li>
          </ul>
          <ul
            v-if="!isLogin"
            class="d-md-none dropdown-profile-navigation-wrapper"
          >
            <li class="d-flex">
              <button
                type="button"
                class="burger-menu"
                @click.stop="toggleDropdownProfileNavigation('mainNavigation')"
              >
                <span class="burger-menu__item"></span>
                <span class="burger-menu__item"></span>
                <span class="burger-menu__item"></span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="d-md-block">
        <div
          class="d-flex align-items-center justify-content-between d-md-none"
        >
          <div v-if="isLogin" class="header-top__cart-wrapper pt-3">
            <cart
              @toggleCard="toggle('cartModal')"
              :locale="locale"
              :default-locale="defaultLocale"
              :user-id="getUserId"
              :base-url-with-locale="baseUrlWithLocale"
            />
          </div>
          <div v-if="isLogin" class="header-top__profile-balance-wrapper pt-3">
            <a class="header-top__text" :href="profileMyBalanceRouter">
              {{ t[locale]['tehnobank.header.your_balance'] }}
            </a>
            <span class="header-top__profile-balance">
              {{ renderUserBalance }} <span class="star">★</span>
            </span>

            <div class="bonuses-expire" v-if="userData.bonuses_will_expire > 0">
              <vl-tooltip :isCloseBtn="true">
                <template #activator="on">
                  <div v-on="on" class="d-flex">
                    <vl-icon-base width="16" height="16" viewBoxWidth="16" viewBoxHeight="16" opacity="1">
                      <vl-icon-exclamation-mark />
                    </vl-icon-base>
                  </div>
                </template>
                <template>
                  <div>
                    {{ t[locale]['profile.my_balance.bonuses_can_expire'].replace('{bonuses}', userData.bonuses_will_expire) }}
                    <a :href="rulesPage" target="_blank">{{ t[locale]['profile.my_balance.rules'] }}</a>.
                  </div>
                </template>
              </vl-tooltip>
            </div>
          </div>
        </div>
        <modal
          @click="toggleDropdownProfileNavigation('mainNavigation')"
          v-if="mainNavigation"
          :margin-top="0"
          cancel-position="right"
        >
          <ul class="dropdown-profile-navigation">
            <li class="dropdown-profile-navigation__item">
              <a class="dropdown-profile-navigation__url" :href="loginRouter">
                {{ t[locale]['tehnobank.header.enter_to_accountV2'] }}
              </a>
            </li>
            <template v-if="showOnHome">
              <li
                class="dropdown-profile-navigation__item"
                v-for="item in homePageMenu"
                :key="item.id"
                @click="scrollTo(item.url)"
              >
                <a class="dropdown-profile-navigation__url" :href="item.url">
                  {{ item.title }}
                </a>
              </li>
            </template>
            <div class="site-language">
              <language-container
                v-if="this.disableOnPage(baseUrlWithLocale)"
                :available-locales="availableLocales"
                :current-path="currentPath"
                :locale="locale"
                :baseUrlWithLocale="baseUrlWithLocale"
                mobileContainer
              />
            </div>
          </ul>
        </modal>
        <ul
          v-if="showOnHome"
          class="site-navigation d-none d-md-flex mt-md-4 mt-lg-40"
        >
          <li
            class="site-navigation__item"
            v-for="item in homePageMenu"
            :key="item.id"
            @click="scrollTo(item.url)"
          >
            <a class="site-navigation__url" :href="item.url">
              {{ item.title }}
            </a>
          </li>
        </ul>
      </div>
      <modal
        @click="toggleDropdownProfileNavigation('mobile')"
        v-if="mobile"
        :margin-top="0"
        cancel-position="right"
      >
        <ul class="dropdown-profile-navigation">
          <li class="dropdown-profile-navigation__item">
            <a class="dropdown-profile-navigation__url" :href="catalogRouter">
              {{ t[locale]['tehnobank.header.catalog'] }}
            </a>
          </li>
          <li
            v-for="(item, index) in profileMenu"
            :key="index"
            class="dropdown-profile-navigation__item"
          >
            <a class="dropdown-profile-navigation__url" :href="item.url">
              {{ item.title }}
            </a>
          </li>
          <li class="dropdown-profile-navigation__item">
            <span class="dropdown-profile-navigation__url" @click="API_LOGOUT">
              {{ t[locale]['authorization.logout.exit'] }}
            </span>
          </li>
          <div class="site-language">
            <language-container
              v-if="this.disableOnPage(baseUrlWithLocale)"
              :available-locales="availableLocales"
              :current-path="currentPath"
              :locale="locale"
              :baseUrlWithLocale="baseUrlWithLocale"
              mobileContainer
            />
          </div>
        </ul>
      </modal>
    </div>
    <div class="container h-100 px-0" style="display: none">
      <div class="row no-gutters justify-content-between h-100">
        <div class="col-24 h-100" v-if="isHideOnThisPage">
          <div
            class="d-none d-md-flex align-items-start flex-column justify-content-center h-100"
          >
            <language-container
              v-if="this.disableOnPage(baseUrlWithLocale)"
              :available-locales="availableLocales"
              :current-path="currentPath"
              :locale="locale"
              :baseUrlWithLocale="baseUrlWithLocale"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import VlTooltip from '@components/@tehnobank/ui/vl-tooltip'
import VlIconBase from '@components/@tehnobank/ui/vl-icons'
import VlIconExclamationMark from '@components/@exim/ui/vl-icons/VlIconeExclamationMark'
import Cart from './cart/Cart'
import Modal from './modal'
import LanguageContainer from './language-container'
import locales from './locales'
import disableLanguageContainer from '@javascript/mixins/disableLanguageContainer'
import {
  ORDER_SHOW,
  CATALOG,
  PROFILE_MY_BALANCE,
  AUTHORIZATION_LOGIN,
} from '@javascript/config/routes'
import { scrollToElementById } from '@javascript/utils/helper-methods'
export default {
  name: 'HeaderTop',
  components: {
    LanguageContainer,
    Cart,
    Modal,
    VlTooltip,
    VlIconBase,
    VlIconExclamationMark
  },
  mixins: [disableLanguageContainer],
  props: {
    availableLocales: {
      type: String,
      default: '',
    },
    currentPath: {
      type: String,
      default: '',
    },
    locale: {
      type: String,
      default: '',
    },
    defaultLocale: {
      type: String,
      default: '',
    },
    baseUrlWithLocale: {
      type: String,
      default: '',
    },
    userData: {
      type: Object,
    },
    isLogin: {
      type: Boolean,
      default: false,
      require: true,
    },
    profileMenu: {
      type: Array,
      default: [],
      require: true,
    },
    isHomePage: {
      type: String,
    },
    homePageMenu: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    t: locales,
    mobile: false,
    tablet: false,
    mainNavigation: false,
    cartModal: false,
  }),
  computed: {
    isOrderPage() {
      const orderRouter = `${this.baseUrlWithLocale}${ORDER_SHOW}`
      return window.location.pathname == orderRouter
    },
    isVerifyEmailPage() {
      const path = window.location.pathname
      const regex = new RegExp('/(registration/verify_welcome)/')

      return path.match(regex)
    },
    isHideOnThisPage() {
      return !this.isOrderPage && !this.isVerifyEmailPage
    },
    renderUserBalance() {
      return this.isLogin ? this.userData.balance : null
    },
    getUserId() {
      return this.userData ? this.userData.id : null
    },
    showOnHome() {
      return JSON.parse(this.isHomePage)
    },
    catalogRouter() {
      return `${this.baseUrlWithLocale}${CATALOG}`
    },
    profileMyBalanceRouter() {
      return `${this.baseUrlWithLocale}${PROFILE_MY_BALANCE}`
    },
    loginRouter() {
      return `${this.baseUrlWithLocale}${AUTHORIZATION_LOGIN}`
    },
    rulesPage() {
      return `${this.baseUrlWithLocale}/topic/rules`
    },
  },
  methods: {
    ...mapActions({
      API_LOGOUT: 'authorization/API_LOGOUT',
    }),
    toggleDropdownProfileNavigation(version) {
      this[version] = !this[version]
    },
    hideDropdownProfileNavigation(version) {
      this[version] = false
    },
    toggle(modalName) {
      this[modalName] = !this.modalName
    },
    scrollTo(id) {
      scrollToElementById(id)
      this.hideDropdownProfileNavigation('mainNavigation')
    },
  },
}
</script>
